import React, { useState } from 'react'

import { constructorContext } from '../Builder'
import Vivre from '../Vivre'
import Loading from '../../Loading'
import { getSession } from '../../../auth'

// Reuses '../Builder' styles.css (dialog/list classes such as
// .settings-body-bot, .BuilderBotSelectorBox) and '../styles.css'
// (.vivre-ura-dialog, .group-flexbox, .no-max-width) explicitly, since this
// component mounts <Vivre/> outside of the Builder page that normally
// provides them.
import '../Builder/styles.css'
import '../styles.css'

// Telephony settings only needs the voice (URA) side of the shared
// Automação > Fluxos VIVRE screen (activeTab 1), never the chatbot side.
// The VIVRE builder itself stays exactly as-is: this only pins the context
// that <Vivremenu/> reads, it does not fork or reimplement it.
const VoiceUras = () => {

    const [loading, setLoading] = useState(false)
    const enterpriseId = getSession().profile.enterprise.id

    return (
        <constructorContext.Provider value={{
            activeTab: 1,
            has_voice: true,
            enterpriseId,
            loading,
            setLoading
        }}>
            <Loading loading={loading} />
            <Vivre />
        </constructorContext.Provider>
    )
}

export default VoiceUras
